export default __webpack_public_path__ + "src/_images/GoalDriven_Icon.svg";